require('./retailLoanInterstitialModal.scss');
require('./retailLoanInterstitialModal.override.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
// @ utilities
const { formatText } = require('core/i18n').i18n;
//@commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { ContentBox } = require("commonsComponents/contentBox");
const IconError = require("assets/images/icon-error.svg");
const { buildEventsModalInterstitial } = require("../../../../loansUtilities/loansHelper")
const {
    recordLinkV2,
} = require('utilities/tagging');
//@constant
const {
    INTERSTITIAL_ODM_DOCUMENT,
    INTERSTITIAL_ODM_DOCUMENT_DOWNLOAD_LINK,
    INTERSTITIAL_PD_DOCUMENT,
    INTERSTITIAL_PD_DOCUMENT_DOWNLOAD_LINK,
    retailLoanDoTaggin: {
        TAGGING_POLITICS,
        TAGGING_BACK,
        TAGGING_CONTINUE,
        TAGGING_VIEW,
        TAGGING_OK
    }
} = require('../../../../loansConstants/index');

class RetailLoanInterstitialModal extends React.Component {

    componentDidMount(){
        const {
            hasErrorUpdatingUser,
            hasErrorConsentsStatus,
            showModal,
            sendEventModalInterstitial
        } = this.props;

        const hasErrors = ( hasErrorConsentsStatus || hasErrorUpdatingUser );

        if(!hasErrors && showModal && sendEventModalInterstitial){
            const customData = buildEventsModalInterstitial({
                etiquetaEvento: TAGGING_VIEW
            });
            recordLinkV2(customData);
        }
    }

    handleGoBackFunction() {
        window.history.back();
    }

    handleDownloadEvents(docType) {
        const customData = buildEventsModalInterstitial({
            etiquetaEvento: TAGGING_POLITICS
        });
        recordLinkV2(customData);
        if (docType === INTERSTITIAL_PD_DOCUMENT) {
            window.open(INTERSTITIAL_PD_DOCUMENT_DOWNLOAD_LINK);
        } else {
            window.open(INTERSTITIAL_ODM_DOCUMENT_DOWNLOAD_LINK);
        }
    }

    buildLinkButtonMessage(docType, documentName) {
        return (
            <OKButton
                onClick={() => this.handleDownloadEvents(docType)}
                modifier="link-emphasize"
                autoHeight
            >
                {documentName}
            </OKButton>
        )
    }

    keyBuilder(context, term) {
        return `${context}-${context}_${term}`
    }

    buildLastDescription() {
        const splitMessage = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialThirdDescription')).split('%s');

        const injectedLinks = [
            { docType: INTERSTITIAL_PD_DOCUMENT, text: this.keyBuilder('retailLoanCatalog', 'interstitialProtectionDataLink') },
            { docType: INTERSTITIAL_ODM_DOCUMENT, text: this.keyBuilder('retailLoanCatalog', 'interstitialODMLink') },
        ];

        const message = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const documentName = link ? formatText(link.text) : '';
            const replacement = link ? this.buildLinkButtonMessage(link.docType, documentName) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return (
            <div className="retail-loan-interstitial-modal__last-description">
                <span>{message}</span>
            </div>
        );
    }

    buildModalContent() {
        const {
            acceptConsentsValue,
            handleChangeInterstitialValue,
            isUpdatingUserConsent
        } = this.props;

        const title = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialTitle'));
        const firstDescription = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialFirstDescription'));
        const checkboxLabel = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialLabelCheck'));
        const secondDescription = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialSecondDescription'));
        const contactData = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialContactData'));
        const openBankTitle = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialOpenBankTitle'));
        const openBankPrivacyEmail = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialOpenBankPrivacyEmail'));
        const openDigitalMarketTitle = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialOpenDigitalMarket'));
        const openDigitalMarketEmail = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialOpenBankOpenDigitalMarketEmail'));
        const lastDescription = this.buildLastDescription();
        const interstitialDisclaimer = formatText(this.keyBuilder('retailLoanCatalog', 'interstitialDisclaimer'));
        
        if(isUpdatingUserConsent){
            return (
                <div className="retail-loan-interstitial-modal__main-content--loading">
                    <LoadingSection/>
                </div> 
            )
        } 

        return (
            <div className="retail-loan-interstitial-modal__main-content" >
                <i className="retail-loan-interstitial-modal__icon-interstitial" />
                <div className="retail-loan-interstitial-modal__container-title">
                    <span>{title}</span>
                </div>
                <span className="retail-loan-interstitial-modal__description">
                    {firstDescription}
                </span>
                <OKCheckbox
                    idName="retail-loan-interstitial-modal-checkbox"
                    extraClass="retail-loan-interstitial-modal__checkbox"
                    label={checkboxLabel}
                    onChange={handleChangeInterstitialValue}
                    value={acceptConsentsValue}
                />
                <span className="retail-loan-interstitial-modal__description">
                    {secondDescription}
                </span>
                <div className="retail-loan-interstitial-modal__container-contact-us">
                    <div>
                        <span className="retail-loan-interstitial-modal__description">{contactData}</span>
                    </div>
                    <div>
                        <span className="retail-loan-interstitial-modal__description">{openBankTitle}</span>
                        <span className="retail-loan-interstitial-modal__text-as-link">{openBankPrivacyEmail}</span>
                    </div>
                    <div>
                        <span className="retail-loan-interstitial-modal__description">{openDigitalMarketTitle}</span>
                        <span className="retail-loan-interstitial-modal__text-as-link">{openDigitalMarketEmail}</span>
                    </div>
                </div>
                {lastDescription}
                <div className="retail-loan-interstitial-modal__disclaimer">
                    <span>{interstitialDisclaimer}</span>
                </div>
            </div>
        );
    }

    buildModalErrorContent(descriptionError) {

        const titleError = formatText("openMarketInterstitialErrorModal-openMarketInterstitialErrorModal_modalTitle");

        return(
            <ContentBox 
                title={titleError}
                titleSeparator={true}
                leftIcon={{icon: IconError}}
                customClassName="retail-loan-interstitial-modal-error"
                hasShadow={false}
            >
                <div className="retail-loan-interstitial-modal-error__wrapper">
                    <p className="retail-loan-interstitial-modal-error__text">{descriptionError}</p>
                </div>

            </ContentBox>
        )


    }

    buildModalInterstitial({
        modalContent, 
        isOpen, 
        primaryButtonText, 
        secondaryButtonText, 
        primaryButtonDisabled, 
        onPrimaryButtonClick,
        footerType,
        classNames
    }){
        return (
            <OKModal
                content={modalContent}
                customCloseButton={<div />}
                footerType={footerType}
                isOpen={isOpen}
                onPrimaryButtonClick={onPrimaryButtonClick}
                onSecondaryButtonClick={()=>{
                    const customData = buildEventsModalInterstitial({
                        etiquetaEvento: TAGGING_BACK
                    });
                    recordLinkV2(customData);
                    this.handleGoBackFunction()
                }}
                overlayClassName={`retail-loan-interstitial-modal ${classNames}`}
                overlayBackgroundClassName={'retail-loan-interstitial-modal-overlay'}
                hideHeader
                primaryButtonDisabled={primaryButtonDisabled}
                primaryButtonText={primaryButtonText}
                secondaryButtonText={secondaryButtonText}
                shouldCloseOnOverlayClick={false}
                size="large"
            />
        );
    }

    buildModalError(messageError) {
        const {
            showModal
        } = this.props;
        
        const buttonTextContinue = formatText("openMarketInterstitialErrorModal-openMarketInterstitialErrorModal_modalPrimaryButton");

        return this.buildModalInterstitial({
            modalContent: this.buildModalErrorContent(messageError),
            isOpen: showModal,
            primaryButtonText: buttonTextContinue,
            onPrimaryButtonClick:() => {
                const customData = buildEventsModalInterstitial({
                    etiquetaEvento: TAGGING_OK,
                    hasError: true
                });
                recordLinkV2(customData);
                this.handleGoBackFunction()
            },
            footerType: "navigation",
            classNames:"retail-loan-interstitial-modal--error",
        });
    }

    buildModalSuccess() {
        const {
            acceptConsentsValue,
            showModal,
            handleUpdateRetailConsents,
            isUpdatingUserConsent
        } = this.props;

        const footerType = isUpdatingUserConsent ? "default" : "navigation";

        return this.buildModalInterstitial({ 
            modalContent: this.buildModalContent(), 
            isOpen: showModal,
            primaryButtonDisabled:!acceptConsentsValue,
            onPrimaryButtonClick: () => {
                const customData = buildEventsModalInterstitial({
                    etiquetaEvento: TAGGING_CONTINUE
                });
                recordLinkV2(customData);
                handleUpdateRetailConsents()
            },
            primaryButtonText:"common-continue",
            secondaryButtonText:"common-back",
            footerType,
            classNames:""
        });
    }

    render() {
        const {
            hasErrorUpdatingUser,
            hasErrorConsentsStatus
        } = this.props;

        const hasErrors = ( hasErrorConsentsStatus || hasErrorUpdatingUser );

        const messageError = hasErrorConsentsStatus ? formatText('openMarketInterstitialGetStatusErrorModal-openMarketInterstitialGetStatusErrorModal_modalDescription') : formatText('openMarketInterstitialErrorModal-openMarketInterstitialErrorModal_modalDescription');

        const modal = hasErrors ? this.buildModalError(messageError) : this.buildModalSuccess();

        if(hasErrors) {
            const customData = buildEventsModalInterstitial({
                etiquetaEvento: TAGGING_VIEW,
                hasError: hasErrors
            });
            recordLinkV2(customData);
        }

        return modal;
    }
}

RetailLoanInterstitialModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    acceptConsentsValue: PropTypes.bool.isRequired,
    handleUpdateRetailConsents: PropTypes.func.isRequired,
    handleChangeInterstitialValue: PropTypes.func.isRequired,
    isUpdatingUserConsent: PropTypes.bool.isRequired,
    hasErrorUpdatingUser: PropTypes.bool.isRequired,
    hasErrorConsentsStatus: PropTypes.bool.isRequired,
    sendEventModalInterstitial: PropTypes.bool.isRequired,
};


module.exports = RetailLoanInterstitialModal;
